export default {
    name: 'ชื่อผู้ติดต่อ',
    tel: 'เบอร์ติดต่อกลับ',
    topic: 'เรื่องที่ต้องการติดต่อ',
    description: 'ข้อความ...',
    submit: 'ส่งข้อความ',
    mailSentSucceed: 'ข้อความถูกส่งเรียบร้อยแล้ว',
    mailSentFailed: 'เกิดข้อผิดพลาดในการส่งข้อความ กรุณาลองใหม่อีกครั้ง'
}
